import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { SilentOrderService } from './silent-order.service';
import { Observable } from 'rxjs';
import { Api } from '../enum/Api';
import { CheckoutData } from '../model/checkout-data';
import { CheckoutSuccessData } from '../model/checkout-success-data';
import { map } from 'rxjs/operators';
import { UpgradeCheckout } from '../model/upgrade-checkout';
import { SelfAttendanceData } from '../model/self-attendance-data';
import { SessionStorageService } from './session-storage.service';

@Injectable()
export class CheckoutService {

  private checkoutSuccessData: CheckoutSuccessData;
  private checkoutData: CheckoutData;

  constructor(
    private httpService: HttpService,
    private silentOrderService: SilentOrderService,
    private sessionStorageService: SessionStorageService
  ) { }

  public getCheckoutSuccessData() {
    return this.checkoutSuccessData;
  }

  public setCheckoutSuccessData(checkoutSuccessData: CheckoutSuccessData) {
    this.checkoutSuccessData = checkoutSuccessData;
    localStorage.setItem('checkoutSuccessData', JSON.stringify(this.checkoutSuccessData));
  }

  public getSessionCheckoutSuccessData() {
    this.setCheckoutSuccessData(new CheckoutSuccessData(JSON.parse(localStorage.getItem('checkoutSuccessData'))));
  }
  // Retorna quanto tempo para o saldo expirar.
  public getBalanceExpirationDate(productFamilyIdentifier: string): Observable<{ daysToExpire: number }> {
  return this.httpService.post(
    'com.serasa.customer/balanceExpirationConfig/getExpirationDate',
    Api.One_Portal,
    {
      productIdentifier: productFamilyIdentifier
    }
  );
}
  public getLocalStorageCheckoutSuccessData() : CheckoutSuccessData {
    return new CheckoutSuccessData(JSON.parse(localStorage.getItem('checkoutSuccessData')));
  }
  /** Faz checkout da venda */
  doCheckout(checkoutData: CheckoutData): Observable<CheckoutSuccessData> {
    const request = checkoutData.getInSaleRequestFormat();

    if (request.paymentMethod.identifier === 'CREDIT_CARD' && !request.paymentMethod.isAdyen) {
      request.paymentMethod.creditCardInformation.cardToken = this.silentOrderService.paymentToken;
    }

    this.checkoutData = checkoutData;

    return this.httpService.post('eCommercePME/cart/checkout', Api.One_Portal, request)
      .pipe(map(result => new CheckoutSuccessData(result)));
  }

  /** Realiza checkout do upgrade */
  doUpgradeCheckout(upgradeCheckoutData: any): Observable<SelfAttendanceData> {
    if (upgradeCheckoutData.paymentData && upgradeCheckoutData.paymentData.identifier === 'CREDIT_CARD') {
      if(!upgradeCheckoutData.paymentData.isAdyen) {
        upgradeCheckoutData.paymentData.card.paymentToken = this.silentOrderService.paymentToken;
        upgradeCheckoutData.paymentData.card.cardNumber = this.maskCreditCardNumber(upgradeCheckoutData.paymentData.card.cardNumber);
      }
    }

    return this.httpService.post('eCommercePME/cart/upgradeCheckout', Api.One_Portal, upgradeCheckoutData)
    .pipe(map(result => new SelfAttendanceData(result)));
  }

  private maskCreditCardNumber(cardNumber: string): string {
    const unmaskedValue = cardNumber.substr(cardNumber.length - 4, 4);
    let maskedValue = cardNumber.substr(0, cardNumber.length - 4);
    maskedValue = maskedValue.split(' ').map(
      digitGroup => {
        let maskedGroup = '';
        while (maskedGroup.length < digitGroup.length) {
          maskedGroup += '*';
        }
        return maskedGroup;
      }
    ).join(' ');
    return maskedValue + unmaskedValue;
  }

}
